export enum EventLabel {
  Upcoming = 'Upcoming event',
  Ongoing = 'Happening now',
  Past = 'Past event',
}
